import { buildInfo, shortCommit } from '@brush/build-info';
import { AboutDialog, VersionBadge, apiVersionState } from '@brush/ui';
import { useState } from 'react';
import { useApiVersion } from '../queries';

/**
 * The version line under the portal's content, and the detail behind it.
 *
 * Not in the rail, unlike the two consoles. Signal orange means "this is you" on this side and the
 * header is where a player reads their own name, card and standing — a build number in that
 * cluster is the one thing up there that is not about them. The foot of the content is where a
 * portal's small print belongs, and unlike room-web this page really does scroll to reach it.
 */
export function About() {
  const [open, setOpen] = useState(false);
  const version = useApiVersion(open);

  return (
    <>
      <VersionBadge
        version={buildInfo.version}
        commit={shortCommit(buildInfo.commit)}
        onClick={() => setOpen(true)}
        className="text-ink-800 hover:text-ink-950"
      />
      {open ? (
        <AboutDialog
          appLabel="Player portal"
          client={buildInfo}
          api={apiVersionState(version)}
          onClose={() => setOpen(false)}
        />
      ) : null}
    </>
  );
}
